import { AccountHub } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import { Hub as BaseHub } from '@bnnvara/hub';
import { Logo } from '@bnnvara/icons/src/components/BrandIcons/Logo';
import { MemberHeart } from '@bnnvara/icons/src/components/UserInterfaceIcons/MemberHeart';
import uniqueId from 'lodash/uniqueId';
import getConfig from 'next/config';
import NextLink from 'next/link';
import Router, { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import useSharedRef from '../../hooks/useSharedRef';
import useUI, {
  TYPE_CLOSE_SEARCH,
  TYPE_TOGGLE_ACCOUNT_HUB,
} from '../../hooks/useUI';
import Link from '../Link';
import { MenuButton } from './Menu/MenuButton';
import NotificationsHub from './NotificationsHub';
import { SearchButton } from './Search/SearchButton';
import * as S from './styled';

const Hub = () => {
  const {
    publicRuntimeConfig: {
      account: { settingsUrl },
    },
  } = getConfig();
  const router = useRouter();
  const { createRef, refs } = useSharedRef();
  const { ref: setRef, inView } = useInView({ threshold: 0 });
  const {
    state: { searchOpen, accountHubOpen },
    dispatch,
  } = useUI();

  const closeHandler = () => dispatch({ type: TYPE_TOGGLE_ACCOUNT_HUB });

  useEffect(() => {
    const handleRouteChange = () => {
      const { query: parameters } = router;

      if (!parameters.query && searchOpen) {
        dispatch({ type: TYPE_CLOSE_SEARCH });
      }
    };

    Router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, router]);

  const ref = createRef('hub');
  const hasHeader = !!refs.brandHeader;
  const isHubSolid = hasHeader && !inView;

  return (
    <>
      <span ref={setRef} />
      <S.HubContainer
        ref={ref}
        solid={isHubSolid}
        aria-label="Menu om te navigeren tussen programma's en om in te loggen."
      >
        <BaseHub
          actions={[
            <Link
              href="/sluit-je-aan"
              onClick={() => track('hub', 'click', 'sluit-je-aan')}
              key="lidworden"
              className="ABtestWordLidKnop"
              disableNextLink
            >
              <S.MemberContainer className="ABtestWordLidKnop">
                <MemberHeart />
                <span>Sluit je aan!</span>
              </S.MemberContainer>
            </Link>,
            <S.Separator key={uniqueId()} />,
            <SearchButton key="search" />,
            <S.Separator key={uniqueId()} />,
            <NotificationsHub key="notification" />,
            <S.Separator key={uniqueId()} />,
            <AccountHub
              key="user"
              closeHandler={closeHandler}
              LinkComponent={NextLink}
              onClick={() => dispatch({ type: TYPE_TOGGLE_ACCOUNT_HUB })}
              isOpen={accountHubOpen}
              accountSettingsUrl={settingsUrl}
            />,
            <S.Separator key={uniqueId()} />,
            <a
              href="https://www.npostart.nl"
              key="npo"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('hub', 'click', 'npo-logo')}
            >
              <S.NPOIcon />
            </a>,
          ]}
        >
          <S.LogoLink
            href="https://www.bnnvara.nl"
            title="bnnvara home"
            onClick={() => track('hub', 'click', 'bnnvara-logo')}
          >
            <Logo />
          </S.LogoLink>

          <S.Separator key={uniqueId()} />
          <MenuButton />
        </BaseHub>
      </S.HubContainer>
    </>
  );
};

export default Hub;
